import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../layout/layout';
import { getFaqAPI } from '../../api/faq';
import { CircularProgress, Box } from '@mui/material';
import { useTheme } from "@mui/material/styles";


const Faq = ({ toggleTheme }) => {
      const theme = useTheme();
    const [faqData, setFaqData] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const containerRef = useRef(null);

    const getFaqData = async () => {
        try {
            setLoading(true);
            const response = await getFaqAPI();
            if (response.data) {
                setFaqData(response.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFaqData();
    }, []);

    useEffect(() => {
        const handleNativeClick = (e) => {
            const anchor = e.target.closest('a');
            if (!anchor) return;

            const href = anchor.getAttribute('href');
            if (!href) return;

            if (anchor.target === '_blank') return;

            // 1. Is this a "Jump Link" to a section on the same page? (e.g., href="#ec2")
            const isHashLink = href.startsWith('#') || 
                               (anchor.hostname === window.location.hostname && 
                                anchor.pathname === window.location.pathname && 
                                anchor.hash !== '');

            if (isHashLink) {
                e.preventDefault(); //  STOP the URL from changing to prevent API refetching!
                
                const targetId = anchor.hash.replace('#', '');
                
                if (targetId) {
                    const targetElement = document.getElementById(targetId) || document.getElementsByName(targetId)[0];
                    
                   if (targetElement) {
    const container = containerRef.current;
    const elementRect = targetElement.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    
    const offsetTop = elementRect.top - containerRect.top + container.scrollTop - 40;

    container.scrollTo({ 
        top: offsetTop, 
        behavior: 'smooth' 
    });
}
                }
                return; // Stop execution here
            }

            if (anchor.hostname === window.location.hostname || href.startsWith('/')) {
                e.preventDefault();
                const internalPath = anchor.pathname + anchor.search + anchor.hash;
                navigate(internalPath);
            }
        };

        const container = containerRef.current;
        if (container) {
            container.addEventListener('click', handleNativeClick);
        }

        return () => {
            if (container) {
                container.removeEventListener('click', handleNativeClick);
            }
        };
    }, [navigate]);

    return (
        <Layout pageType="sideBar" toggleTheme={toggleTheme}>
            <Box ref={containerRef} mx={2} sx={{ overflow: 'auto', height: 'calc(100vh - 90px)', p:2, bgcolor: theme.palette.background.default,
 }}>
                {loading ? (
                    <CircularProgress size={24} sx={{ justifyContent: "center", textAlign: "center", display: 'flex', width: '100%' }} />
                ) : (
                    faqData.map((faq) => (
                        <div key={faq.id} style={{ marginBottom: '20px' }}>
                            <div dangerouslySetInnerHTML={{ __html: faq.description }}></div>
                        </div>
                    ))
                )}
            </Box>
        </Layout>
    );
};

export default Faq;